import {
  CABIN_CODE,
  CHECK_IN_STATUS,
  PRODUCT_CODE,
  SEAT_ASSIGN_STATUS,
  TravelReservation_PaxTrip
} from '@com-delta-idp/mnx-trip-management-shared-ui';

export const PASSENDER_TRIP: TravelReservation_PaxTrip = {
  tripId: 1,
  checkinStatus: CHECK_IN_STATUS.CHECKED_IN,
  passengerSegments: [
    {
      segmentId: 1,
      bookedCabinClass: {
        code: CABIN_CODE.Y,
        name: 'Main Cabin',
        productCode: PRODUCT_CODE.DCP
      },
      checkinStatus: CHECK_IN_STATUS.CHECKED_IN,
      passengerLegs: [
        {
          legId: 1,
          seatAssignments: [
            {
              seat: {
                actualCabinClass: [
                  {
                    code: CABIN_CODE.Y,
                    name: 'Main Cabin',
                    productCode: PRODUCT_CODE.DCP
                  }
                ],
                column: 'D',
                number: '16D',
                seatRow: {
                  number: 16
                }
              },
              seatAssignmentType: SEAT_ASSIGN_STATUS.ASSIGNED
            }
          ],
          redEye: false
        }
      ]
    },
    {
      segmentId: 2,
      bookedCabinClass: {
        code: CABIN_CODE.Y,
        name: 'Main Cabin',
        productCode: PRODUCT_CODE.DCP
      },
      checkinStatus: CHECK_IN_STATUS.CHECKED_IN,
      passengerLegs: [
        {
          legId: 1,
          seatAssignments: [
            {
              seat: {
                actualCabinClass: [
                  {
                    code: CABIN_CODE.Y,
                    name: 'Main Cabin',
                    productCode: PRODUCT_CODE.DCP
                  }
                ],
                column: 'G',
                number: '17G',
                seatRow: {
                  number: 17
                }
              },
              seatAssignmentType: SEAT_ASSIGN_STATUS.RESERVED
            }
          ],
          redEye: false
        }
      ]
    }
  ]
};
